import React from 'react';
import { useRouter } from 'next/router';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import {
  CardDescriptionContainer,
  CardStyled,
  DescriptionFieldText,
  ImageContainer,
  ImageStyled,
  TitleFieldText,
  TypeFieldText,
} from './CardNews.style';
import { Newsa } from '../../../models/auto-generated-strapi-types/types/Newsa';
import { capitalizeOnlyFirstLetter } from 'corporate-utils';

interface CardProps {
  data: Newsa;
}

const CardNews: React.FC<CardProps> = ({ data }) => {
  const router = useRouter();
  const { attributes } = data || {};
  const { coverImage, title, description, category } = attributes || {};

  const goToNews = (news: Newsa & { attributes: { url?: string } }): void => {
    if (news?.attributes?.url) {
      router.push(news.attributes.url);
    }
  };

  return (
    <CardStyled onClick={() => goToNews(data)}>
      <ImageContainer $hasImage={!!coverImage?.data?.attributes?.url}>
        <ImageStyled
          src={coverImage?.data?.attributes?.url || DEFAULT_IMAGE}
          $hasImage={!!coverImage?.data?.attributes?.url}
          alt={coverImage?.data?.attributes?.alternativeText || ''}
        />
      </ImageContainer>
      <CardDescriptionContainer>
        <TypeFieldText>
          {category ? capitalizeOnlyFirstLetter(category) : ''}
        </TypeFieldText>
        <TitleFieldText>
          {title ? capitalizeOnlyFirstLetter(title) : '-'}
        </TitleFieldText>
        <DescriptionFieldText>
          {description ? capitalizeOnlyFirstLetter(description) : '-'}
        </DescriptionFieldText>
      </CardDescriptionContainer>
    </CardStyled>
  );
};

export default CardNews;
